"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconKeyFigures = function IconKeyFigures(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M9 16.002H3v2h6zM10 19H2v2h8zM21 16.002h-6v2h6zM22 19h-8v2h8zM5 8.006c1.01-.539 2.216-.689 2-1.999-.282-2.029-2.8-.506-4 0V4.008a4.2 4.2 0 0 1 3-1 3.1 3.1 0 0 1 2.594 4.645A3.1 3.1 0 0 1 7 9.006c-.663.313-2.12.6-2 1.999h4v1.999H3c0-3.647 0-3.987 2-4.998M18 3.009h3v5.997h1v1.999h-1v1.999h-2v-2h-5V9.007zm1 1.999-3 3.998h3z"
  })));
};

export { IconKeyFigures, IconKeyFigures as default };
